import * as React from "react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function Hero() {
  return <section id="hero" className="relative w-full min-h-[300px] md:min-h-[400px] flex items-center bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/hero_contact_bg.png)]">
      {}
      <div className="absolute inset-0 bg-foreground/70" />

      <div className="page-container relative z-10 flex flex-col items-start justify-center w-full">
        <Breadcrumb className="mb-4">
          <BreadcrumbList className="text-white/80 sm:gap-2">
            <BreadcrumbItem>
              <BreadcrumbLink asChild className="hover:text-white text-white/80 transition-colors">
                <Link to="/">Home</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-white/60" />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-white font-medium">Kontakt</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <h1 className="font-default text-4xl md:text-5xl lg:text-[48px] font-bold text-white tracking-tight">
          Kontakt
        </h1>
      </div>
    </section>;
}